/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import { useInView } from 'react-intersection-observer';
import './about.css'
import ME from '../../assets/me-about.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  const { ref: aboutRef, inView: myElementIsVisible } = useInView();
  
  let titleStyle = myElementIsVisible ? 'fade-in' : 'fade-out'

  let meImage = 'about__me '
  meImage += myElementIsVisible ? 'show-from-left' : 'hide-from-left'

  let cards = 'about__card '
  cards += myElementIsVisible ? 'show-from-right' : 'hide-from-right'

  let letstalk = 'btn btn-primary '
  letstalk += myElementIsVisible ? 'show-from-bottom' : 'hide-from-bottom'

  return (
    <section id='about' ref={aboutRef}>
      <h5 className={titleStyle}>Get To Know</h5>
      <h2 className={titleStyle}>About Me</h2>

      <div className="container about__container">
        <div className={meImage}>
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className={cards}>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>1+ Year Working</small>
            </article>

            <article className={cards}>
              <FiUsers className='about__icon'/>
              <h5>Clients</h5>
              <small>1 Local</small>
            </article>

            <article className={cards}>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small>3 Completed</small>
            </article>
          </div>

          <p className={titleStyle}>
            I'm an ambitious Programmer. I work well with little to no supervision, am self-motivated, and am extremely hard working. I have an incredible passion for my work and I hunger for new knowledge, and skills. I always give my 100% on every project I work on.  
          </p>

          <a href="#contact" className={letstalk}>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About